// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1mqoA","label":"SetPasswdForm_label__3N1ii"};